// assets/mega-menu-enhancer.js
(function () {
  // Selecciona todos los dropdowns del header
  const SELECTOR_TEXTS =
    // span que contiene el texto dentro del <a>
    '.header__dropdown .navlink--grandchild .navtext, ' +
    '.header__dropdown .navlink--child .navtext';

  const SELECTOR_MOBILE_TEXTS = '.mobile-menu .sliderow__title > span';

  function enhance(container = document) {
    const textNodes = container.querySelectorAll(SELECTOR_TEXTS);

    textNodes.forEach((span) => {
      if (!span) return;
      if (span.dataset.kitProcessed === '1') return; // evita reprocesos

      const raw = (span.textContent || '').trim();
      if (!raw.includes('|')) return;

      const parts = raw.split('|');
      const need = (parts[0] || '').trim();
      const kit  = (parts[1] || '').trim();

      // Marcar como procesado
      span.dataset.kitProcessed = '1';

      // Añadimos clase al <a> contenedor para poder maquetar con grid
      const anchor = span.closest('a');
      if (anchor && !anchor.classList.contains('kit-line')) {
        anchor.classList.add('kit-line');
      }

      // Reemplazamos el contenido del span.navtext por 3 spans
      // (no insertamos HTML en el menú; solo transformamos el texto existente)
      span.textContent = '';
      const sNeed = document.createElement('span');
      sNeed.className = 'need';
      sNeed.textContent = need;

      const sArrow = document.createElement('span');
      sArrow.className = 'arrow';
      sArrow.setAttribute('aria-hidden', 'true');

      const sKit = document.createElement('span');
      sKit.className = 'kit';
      sKit.textContent = kit;

      span.appendChild(sNeed);
      span.appendChild(sArrow);
      span.appendChild(sKit);
    });

  }

  function enhanceMobile(scope = document) {
  const nodes = scope.querySelectorAll(SELECTOR_MOBILE_TEXTS);
  nodes.forEach(span => {
    if (!span) return;
    if (span.dataset.mmMobileProcessed === '1') return;

    const raw = (span.textContent || '').trim();
    const anchor = span.closest('a');
    const lower = raw.toLowerCase();

    // Casos simples sin separador (CTA)
    if (lower === 'haz el quiz') {
      if (anchor) anchor.classList.add('quiz-btn');
      span.dataset.mmMobileProcessed = '1';
      return;
    }
    if (lower === 'ver todos') {
      if (anchor) anchor.classList.add('view-all');
      span.dataset.mmMobileProcessed = '1';
      return;
    }

    // Partir por "|"
    if (!raw.includes('|')) return;

    const parts = raw.split('|').map(s => s.trim());
    const primary   = parts[0] || ''; // arriba (Kit)
    const secondary = parts[1] || ''; // abajo (Necesidad)

    span.dataset.mmMobileProcessed = '1';
    span.textContent = '';

    const top = document.createElement('span');
    top.className = 'mm-mobile-primary';
    top.textContent = primary;

    const bottom = document.createElement('span');
    bottom.className = 'mm-mobile-secondary';
    bottom.textContent = secondary;

    span.appendChild(top);
    span.appendChild(bottom);
  });
}


  // 1) Al cargar
  document.addEventListener('DOMContentLoaded', () => enhance(document));

  document.addEventListener('DOMContentLoaded', () => { enhanceMobile(document);});

  // 2) Por si el mega menú se inyecta/rehidrata después
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((n) => {
          if (!(n instanceof HTMLElement)) return;
          if (n.matches('.header__dropdown, .header__dropdown__inner, .dropdown__family')) {
            enhance(n);
          }
          // fallback: si dentro hay navtext, también
          if (n.querySelector && n.querySelector('.navtext')) enhance(n);
        });
      }
    }

  const _obsEnhanceMobile = (n) => {
    enhanceMobile(n);
  };

  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
